import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3844d146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-x4 px-x8 o-scrollbar-y scroll-container max-height" }
const _hoisted_2 = { class: "mb-x6 text-center" }
const _hoisted_3 = ["innerHTML"]

import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import useFreightInformation from '@/shared/product/freight-information/useFreightInformation';


export default /*#__PURE__*/_defineComponent({
  __name: 'FreightInfoDialog',
  setup(__props) {

const { freightInfo, isOpen, toggleFreightInfo } = useFreightInformation();


return (_ctx: any,_cache: any) => {
  return (_unref(freightInfo) && _unref(isOpen))
    ? (_openBlock(), _createBlock(BaseDialog, {
        key: 0,
        "is-open": _unref(isOpen),
        class: "fixed inset-x-0 p-x3 sm:p-30 mx-auto z-1 bg-white sm:relative sm:inset-auto w-screen-90 max-h-screen-90 sm:w-screen-80 md:px-x5 md:pb-x3 md:max-w-700",
        onClose: _unref(toggleFreightInfo)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(freightInfo)?.title), 1),
            _createElementVNode("div", {
              innerHTML: _unref(freightInfo)?.content
            }, null, 8, _hoisted_3)
          ])
        ]),
        _: 1
      }, 8, ["is-open", "onClose"]))
    : _createCommentVNode("", true)
}
}

})